function initEnergyInfo () {

	const energyInfoLogo = document.querySelector('#jsEnergyInfoLogo');

	const openEnergyInfoModal = (e) => {

		e.preventDefault();

		$(document.body).lpModal({
			onInit: true,
			content: $('#jsEnergyInfoModalData'),
			width: 810,
			height: 610
		});

	};

	if (energyInfoLogo) {

		energyInfoLogo.addEventListener('click', openEnergyInfoModal);

	}

}

export default initEnergyInfo;
